export default {"src":"/_next/static/media/sneakMessenger.76999eb8.svg","height":382,"width":320};